module.exports = __webpack_public_path__ + "b7ee69ed64a96aeb1744a6d6f3f4bfa6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-14.png
// module id = 2141
// module chunks = 0